import { ICognitoUserPoolData } from "amazon-cognito-identity-js";

export const PASSWORD_REGEX = /\S{6,98}$/;
// /^(?=.*[0-9])(?=.*[\^$*.[\]{}()?\-“!@#%&/,><’:;|_~`])\S{6,98}$/;
export const PASSWORD_REQUIREMENT = "Password must be at least 6 characters.";
// "Password must be at least 8 characters and include numbers and special characters ( @ ! # .....)"
export const MAX_NAME_LENGTH = 70;
export const CONFIRM_CODE_LENGTH = 6;
export const MAX_AVATAR_SIDE_LENGTH = 300;
export const MIN_AVATAR_SIDE_LENGTH = 120;
export const MAX_AVATAR_SIZE = 6000000; //(in bytes)
export const MAX_EFFICE_ICON_SIDE_LENGTH = 300;
export const MIN_EFFICE_ICON_SIDE_LENGTH = 120;
export const MAX_EFFICE_ICON_SIZE = 6000000; //(in bytes)
export const MAX_ROOT_EFFICE_NAME = 100; //(in characters)
export const MAX_EFFICE_CONTENT_CHARS = 2000; //(in characters)

export const DRAG_LOOP_MS = 100; // (ms) 1000/25fps - 40 is a good number when testing
export const MEDIA_LOOP_INTERVAL = 500; // (ms)
export const SPACEBOX_ASPECT_RATIO = 1.78; // coordinate with SCSS

export const MAX_CONCURRENT_EXPANDED_BRANCHES = 4;

// Space Sizes 1-4
// Size 1: Pop:  1-14  Graphic Size: 8% 6% 0.5  (Size: myCircle-Width% remoteCircle-Width% MEDIA_RANGE_2_SPACE_HEIGHT)
// Size 2: Pop: 15-29  Graphic Size: 6% 5% 0.4
// Size 3: Pop: 30-54  Graphic Size: 5% 4% 0.2
// Size 4: Pop: 55-100 Graphic Size: 4% 3% 0.15
export const SPACE_SIZE_VALUES = {
  // level: {startingPopulation, mediaRange2HeightOfSpaceBox, fontSize, edgeBuffer%}
  1: { pop: 0, mr2h: 0.41, fs: 0.05, eBuff: 0.075 },
  2: { pop: 15, mr2h: 0.34, fs: 0.04, eBuff: 0.055 },
  3: { pop: 30, mr2h: 0.24, fs: 0.03, eBuff: 0.045 },
  4: { pop: 55, mr2h: 0.16, fs: 0.022, eBuff: 0.035 },
};

export const VOICE_ATTENUATION = 4; //
export const VIDEO_BUFFER = 30; // (ms)
export const AUDIO_BUFFER = 30; // (ms)
export const VIDEO_TEST_LAG = 1000; // (ms)
export const NETWORK_MONITOR_INTERVAL = 20000;
export const PARTICIPANT_UPDATE_LOOP_TIME = 250;
export const GRID_VIDEO_ASPECT_RATIO = 0.6; // 4:3 is 0.75
export const GRID_VIDEO_MARGIN = 10; // between squares
export const MIC_LEVEL_REFRESH_INTERVAL = 200;
export const MAX_BUZZED = 5;
export const MAX_SPACE_CHAT_HISTORY = 200;
export const NOTIFICATION_TIME = 4500;

export const MAX_PEOPLE_IN_SPACE = 100;
export const MAX_CONCURRENT_VIDEOS = 9;

export const POOL_DATA: ICognitoUserPoolData = {
  UserPoolId: process.env.REACT_APP_USER_POOL_ID!, // Your user pool id here
  ClientId: process.env.REACT_APP_USER_POOL_CLIENT_ID!, // Your client id here
};
// NEED TO CHANGE THE SOCKET URLS TO SECURE CONNECTIONS
let api_url = null;
let socket_url = null;
let invite_link_start_v01 = null;
if (process.env.NODE_ENV === "production") {
  api_url = "https://" + process.env.REACT_APP_BACKEND_DOMAIN + "/";
  socket_url = "wss://" + process.env.REACT_APP_BACKEND_DOMAIN + "/socket";
  invite_link_start_v01 =
    "https://" + process.env.REACT_APP_FRONTEND_DOMAIN + "/join/";
} else {
  // api_url = "https://cdc5-60-241-253-42.ngrok.io";
  // socket_url = "wss://cdc5-60-241-253-42.ngrok.io/socket";
  // invite_link_start_v01 = "https://cdc5-60-241-253-42.ngrok.iojoin/";

  api_url = "http://localhost:4000/";
  socket_url = "ws://localhost:4000/socket";
  invite_link_start_v01 = "http://localhost:3000/join/";
}

export const API_URL = api_url;
export const SOCKET_URL = socket_url;
export const AVATAR_CDN = process.env.REACT_APP_AVATAR_CDN;
export const INVITE_LINK_START_V01 = invite_link_start_v01;
export const MAX_LATEST_EFFICE_BATCH_SIZE = 50;
export const MAX_PINNED_PUBLIC_EFFICE_BATCH_SIZE = 50;
export const MAX_PINNED_PRIVATE_EFFICE_BATCH_SIZE = 30;
export const MAX_MEMBER_BATCH_SIZE = 30;
export const MAX_SUB_EFFICE_COUNT = 30;
export const MAX_EFFICE_DEPTH = 30;
export const DOUBLE_CLICK_SPEED = 250; // (ms)

export const ADMIN_CODE = 1;
export const MEMBER_CODE = 0;

export const APP_CODE_BRANCH = 0;
export const APP_CODE_TEXT_CHANNEL = 1;
export const APP_CODE_ROOM = 2;
export const APPS_AVAILABLE = [
  {
    appId: APP_CODE_BRANCH,
    name: "branch",
    suggestion: "team, department, category, class ....",
  },
  {
    appId: APP_CODE_TEXT_CHANNEL,
    name: "channel",
    suggestion: "topic, subject, theme ....",
  },
  {
    appId: APP_CODE_ROOM,
    name: "room",
    suggestion: "classroom, office, hall ....",
  },
];

export const NONCE_EPOCH = 1624435755572;
export const NONCE_MS_COUNT = 4194304;
export const EFFICE_ID_LENGTH = 19;
